import { Falcon } from '@pocketlaw/tetris/macro';
import { ListButton } from '../ListButton';
export function TasksButton() {
    return <ListButton settingsKey="tasks" icon={<Falcon icon="check-circle"/>}/>;
}
